<template>
  <div>
    <b-form>
      <b-row>
        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Nome"
            label-for="username"
          >
            <b-form-input
              id="username"
              v-model="perfilData.perfil_acesso_nome"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Status"
            label-for="user-status"
          >
            <v-select
              v-model="perfilData.perfil_acesso_ativo"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="statusOptions"
              :reduce="val => val.value"
              :clearable="false"
              input-id="user-status"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>

    <!-- Action Buttons -->
    <b-button
      variant="primary"
      class="mb-1 mb-sm-0 mr-0 mr-sm-1"
      :block="$store.getters['app/currentBreakPoint'] === 'xs'"
      type="submit"
      @click="() => onSubmit(perfilData)"
    >
      Salvar
    </b-button>

  </div>
</template>

<script>
import {
  BButton, BMedia, BAvatar, BRow, BCol, BFormGroup, BFormInput, BForm, BTable, BCard, BCardHeader, BCardTitle, BFormCheckbox,
} from 'bootstrap-vue';
import { avatarText } from '@core/utils/filter';
import vSelect from 'vue-select';
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils';
import { ref } from '@vue/composition-api';
import store from '@/store';
import Notifier from '@/libs/Notifier';
import useUsersList from '../perfilAcesso-list/PerfilAcessoList.vue';

export default {
  components: {
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    vSelect,
  },
  props: {
    perfilData: {
      type: Object,
      required: true,
    },
    permissao: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const notify = new Notifier();
    const statusOptions = [
      { label: 'Ativo', value: 1 },
      { label: 'Inativo', value: 0 },
    ];

    const permissionsData = [
      {
        read: true,
        write: false,
        create: false,
        delete: false,
      },
    ];
    const onSubmit = (perfilData) => {
      console.log(perfilData);
      store.dispatch('app-perfilAcesso/putPerfilAcesso', perfilData)
        .then(() => {
          notify.success('Alterado com sucesso');
        });
    };
    // ? Demo Purpose => Update image on click of update
    const refInputEl = ref(null);
    const previewEl = ref(null);

    const tabelaPermissoes = [
      { key: 'action', label: 'Ação', sortable: true },
      { key: 'subject', label: 'Assunto' },
    ];
    return {
      tabelaPermissoes,
      onSubmit,
      statusOptions,
      permissionsData,
      //  ? Demo - Update Image on click of update button
      refInputEl,
      previewEl,
    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';
</style>
